module.exports = __webpack_public_path__ + "static/media/televenditavistointv.568b1554.png";